
















import DocumentLink from '@/components/DocumentLink'

export default {
    name: 'ButtonGroup',
    
    components:
        DocumentLink: DocumentLink

    data: -> fields: @defaultFields

    computed: 
        isDark: -> @$parent.isDark
        buttonClass: ->
            'uk-button-default': @isDark,
            'uk-button-secondary': !@isDark

    methods: 
        defaultFields: ->
            buttons: []

        setContent: (document) ->
            fields = 
                buttons: document.items
            $.extend @fields, fields

    created: ->
        @setContent @$attrs.document


}
